import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-flamingo-confirm-dialog',
    template: `
    <div mat-dialog-title>{{ data.title }}</div>
    <div mat-dialog-content>
      <p [innerHtml]="data.description"></p>
    </div>
    <div mat-dialog-actions [align]="'end'">
      @if (data.cancel) {
        <button [tabIndex]="-1" type="button" mat-button color="accent"
        [mat-dialog-close]="undefined">{{ data.cancel }}</button>
      }
      <button mat-raised-button [mat-dialog-close]="true" color="accent" class="btn-margin">{{ data.confirm }}</button>
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlamingoConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FlamingoConfirmDialogOptions>,
    @Inject(MAT_DIALOG_DATA) public data: FlamingoConfirmDialogOptions) {
  }

  close(res: boolean): void {
    this.dialogRef.close(res);
  }
}

export interface FlamingoConfirmDialogOptions {
  title?: string;
  description?: string;
  confirm?: string;
  cancel?: string;
}
